import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {
    httpGetAttachmentSignedUrl,
    HttpGetAttachmentSignedUrlOptions,
    HttpGetAttachmentSignedUrlResponse
} from '@/services/address.http'

export const useGetAttachmentSignedUrl = ({
    urlParams,
    options
}: {
    urlParams: HttpGetAttachmentSignedUrlOptions['urlParams']
    options?: Omit<UseQueryOptions<HttpGetAttachmentSignedUrlResponse>, 'queryKey' | 'queryFn'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.ATTACHMENT_SIGNED_URL, urlParams],
        queryFn: () => httpGetAttachmentSignedUrl({urlParams}),
        ...options
    })
